import React from 'react';
import { Carousel } from 'antd';

import poster2026 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/wsw-2026-poster-01-400x492.png';
import poster2025 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/wsw-2025-poster-01-400x492.jpg';
import poster2024 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/wsw-2024-poster-01-400x492.jpg';
import poster2023 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/wsw-2023-poster-01-400x492.jpg';
import poster2022 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/wsw-2022-poster-01-400x492.jpg';
import poster2021 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2021-400x490.png';
import poster2020 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2020-400x491.png';
import poster2019 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2019-400x491.png';
import poster2018 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2018-400x491.png';
import poster2016 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2016-400x491.png';
import poster2015 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2015-400x491.png';
import poster2014 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2014-400x491.png';
import poster2013 from '../../../../Assets/Linkages/WorldSpaceWeek/Posters/WSW_2013-400x491.png';

const posters = [
  { year: '2026', src: poster2026 },
  { year: '2025', src: poster2025 },
  { year: '2024', src: poster2024 },
  { year: '2023', src: poster2023 },
  { year: '2022', src: poster2022 },
  { year: '2021', src: poster2021 },
  { year: '2020', src: poster2020 },
  { year: '2019', src: poster2019 },
  { year: '2018', src: poster2018 },
  { year: '2016', src: poster2016 },
  { year: '2015', src: poster2015 },
  { year: '2014', src: poster2014 },
  { year: '2013', src: poster2013 },
];

const sliderSettings = {
  autoplay: true,
  autoplaySpeed: 2800,
  dots: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 3 } },
    { breakpoint: 850, settings: { slidesToShow: 2 } },
    { breakpoint: 560, settings: { slidesToShow: 1 } },
  ],
};

const WorldSpaceWeekLegacyPosters = () => (
  <section className="world-space-week-poster-legacy" aria-labelledby="world-space-week-poster-legacy-title">
    <div className="world-space-week-legacy-inner">
      <header className="world-space-week-legacy-header">
        <p className="section-eyebrow">TWO DECADES OF IMPACT</p>
        <h2 id="world-space-week-poster-legacy-title">Our Legacy</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          Since 2005, the Institute of Space Technology (IST) has proudly led the celebration of
          World Space Week in Pakistan, engaging generations of students through space-themed
          learning, competitions, workshops, exhibitions, and hands-on projects.
        </p>
        <p>
          These legacy posters revisit milestone editions of World Space Week and reflect IST and
          NCGSA&apos;s continuing commitment to space education, creativity, and national outreach.
        </p>
      </header>

      <div className="world-space-week-legacy-slider">
        <Carousel {...sliderSettings}>
          {posters.map((poster) => (
            <div className="world-space-week-legacy-slide" key={poster.year}>
              <figure>
                <img src={poster.src} alt={`World Space Week ${poster.year} poster`} loading="lazy" />
                <figcaption>World Space Week {poster.year}</figcaption>
              </figure>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  </section>
);

export default WorldSpaceWeekLegacyPosters;
